<div class="hint" [ngClass]="{'hint--small': size === 'SMALL'}">
  <img *ngIf="icon" [src]="icon" alt="" class="hint__icon">
  <div class="hint__content"
       [ngClass]="{'hint__content--rounded': rounded}">
    <span [innerHTML]="content | translate | safeHtml"></span>
    <div *ngIf="arrowDown" class="hint__arrow hint__arrow--down"></div>
    <div *ngIf="arrowUp" class="hint__arrow hint__arrow--up"></div>
    <div *ngIf="arrowLeft" class="hint__arrow hint__arrow--left"></div>
  </div>
</div>
